var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEngineeringinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.49 28.26a1.671 1.671 0 01-.49-1.177V12.917a1.666 1.666 0 011.667-1.667h16.666A1.671 1.671 0 0130 12.917v14.166a1.671 1.671 0 01-1.667 1.667H11.667a1.671 1.671 0 01-1.177-.49zm8.676-8.677a.833.833 0 00-.244-.589l-2.083-2.083a.835.835 0 10-1.178 1.178l1.347 1.347a.21.21 0 010 .295l-1.347 1.346a.833.833 0 101.178 1.179l2.084-2.084a.834.834 0 00.244-.589zm5.173 2.256a.834.834 0 00-.589-1.422h-3.333a.834.834 0 000 1.666h3.333a.834.834 0 00.59-.244z",
    fill: "#0F0449"
  })));
}

export default SvgEngineeringinline;